export const checklistTemplates = [
  // Tab 1: Metadata Setup
  {
    id: 'metadata-1',
    tab: 'Metadata Setup',
    label: 'Title reflects core promise',
    description: 'Ensure your title clearly communicates the main benefit or transformation your book offers'
  },
  {
    id: 'metadata-2',
    tab: 'Metadata Setup',
    label: 'Subtitle clarifies audience + transformation',
    description: 'Your subtitle should specify who the book is for and what they will gain'
  },
  {
    id: 'metadata-3',
    tab: 'Metadata Setup',
    label: 'Description uses recommended structure',
    description: 'Hook, problem, solution, transformation - structure your description for maximum impact'
  },
  {
    id: 'metadata-4',
    tab: 'Metadata Setup',
    label: 'Keywords naturally integrated',
    description: 'Weave relevant keywords into your description without forcing them'
  },
  {
    id: 'metadata-5',
    tab: 'Metadata Setup',
    label: 'Author bio written in friendly, trustworthy tone',
    description: 'Create a bio that builds connection and credibility with your readers'
  },

  // Tab 2: Interior File Prep
  {
    id: 'interior-1',
    tab: 'Interior File Prep',
    label: 'Manuscript fully edited',
    description: 'Complete all developmental, line, and copy editing passes'
  },
  {
    id: 'interior-2',
    tab: 'Interior File Prep',
    label: 'Consistent chapter headings',
    description: 'Ensure all chapter titles follow the same formatting and style'
  },
  {
    id: 'interior-3',
    tab: 'Interior File Prep',
    label: 'Proper page breaks inserted',
    description: 'Add page breaks before each chapter and major section'
  },
  {
    id: 'interior-4',
    tab: 'Interior File Prep',
    label: 'Standard fonts and spacing used',
    description: 'Use industry-standard formatting for readability and professionalism'
  },
  {
    id: 'interior-5',
    tab: 'Interior File Prep',
    label: 'Front matter prepared',
    description: 'Include title page, copyright page, dedication, and table of contents as needed'
  },
  {
    id: 'interior-6',
    tab: 'Interior File Prep',
    label: 'Back-matter placeholders included',
    description: 'Reserve space for author bio, acknowledgments, and additional resources'
  },

  // Tab 3: Cover File Prep
  {
    id: 'cover-1',
    tab: 'Cover File Prep',
    label: 'Professional cover design finalized',
    description: 'Ensure your cover meets professional publishing standards'
  },
  {
    id: 'cover-2',
    tab: 'Cover File Prep',
    label: 'Matches genre/reader expectations',
    description: 'Verify your cover signals the right genre and appeals to your target audience'
  },
  {
    id: 'cover-3',
    tab: 'Cover File Prep',
    label: 'Subtitle and author name visible',
    description: 'Test readability at thumbnail size - all text should be clearly legible'
  },
  {
    id: 'cover-4',
    tab: 'Cover File Prep',
    label: 'Print wrap sized correctly',
    description: 'Ensure print cover dimensions match your trim size and page count'
  },
  {
    id: 'cover-5',
    tab: 'Cover File Prep',
    label: 'Spine width matches page count',
    description: 'Calculate and verify spine width based on final page count and paper type'
  },

  // Tab 4: Keywords & Categories
  {
    id: 'keywords-1',
    tab: 'Keywords & Categories',
    label: 'Competitor research completed',
    description: 'Study successful books in your category to understand keyword strategies'
  },
  {
    id: 'keywords-2',
    tab: 'Keywords & Categories',
    label: 'Keywords match felt needs/search terms',
    description: 'Choose keywords based on what your ideal reader actually searches for'
  },
  {
    id: 'keywords-3',
    tab: 'Keywords & Categories',
    label: 'Categories chosen for discoverability',
    description: 'Select categories where you can realistically rank and be discovered'
  },

  // Tab 5: ISBN + Copyright
  {
    id: 'isbn-1',
    tab: 'ISBN + Copyright',
    label: 'ISBNs assigned correctly',
    description: 'Assign unique ISBNs for ebook and print versions if using your own'
  },
  {
    id: 'isbn-2',
    tab: 'ISBN + Copyright',
    label: 'Copyright page complete',
    description: 'Include all necessary copyright information and legal notices'
  },
  {
    id: 'isbn-3',
    tab: 'ISBN + Copyright',
    label: 'Scripture citations handled correctly',
    description: 'Properly attribute Bible translations and check permission requirements'
  },
  {
    id: 'isbn-4',
    tab: 'ISBN + Copyright',
    label: 'Author/publisher rights verified',
    description: 'Confirm you have all necessary rights for content, images, and quotes'
  },

  // Tab 6: Back Matter & Author Bio
  {
    id: 'backmatter-1',
    tab: 'Back Matter & Author Bio',
    label: 'Author bio finalized',
    description: 'Create a compelling bio that builds trust and connection'
  },
  {
    id: 'backmatter-2',
    tab: 'Back Matter & Author Bio',
    label: 'Acknowledgments written',
    description: 'Thank those who contributed to your book and ministry'
  },
  {
    id: 'backmatter-3',
    tab: 'Back Matter & Author Bio',
    label: 'Email list invitation added',
    description: 'Include a clear call-to-action for readers to join your community'
  },
  {
    id: 'backmatter-4',
    tab: 'Back Matter & Author Bio',
    label: 'Next-book teaser (for fiction)',
    description: 'Give fiction readers a preview of what\'s coming next in your series'
  },
  {
    id: 'backmatter-5',
    tab: 'Back Matter & Author Bio',
    label: 'Notes or references (for nonfiction)',
    description: 'Include source citations, additional resources, and study guides as appropriate'
  },

  // Tab 7: Audio Read Pass
  {
    id: 'audio-1',
    tab: 'Audio Read Pass',
    label: 'Completed audio read-through',
    description: 'Listen to your entire manuscript using text-to-speech technology'
  },
  {
    id: 'audio-2',
    tab: 'Audio Read Pass',
    label: 'Marked awkward or unclear sentences',
    description: 'Note any sentences that sound confusing or difficult when heard aloud'
  },
  {
    id: 'audio-3',
    tab: 'Audio Read Pass',
    label: 'Fixed pacing issues',
    description: 'Adjust sentence length and paragraph breaks for better flow'
  },
  {
    id: 'audio-4',
    tab: 'Audio Read Pass',
    label: 'Corrected tone inconsistencies',
    description: 'Ensure your voice and tone remain consistent throughout'
  },
  {
    id: 'audio-5',
    tab: 'Audio Read Pass',
    label: 'Verified dialog/narration rhythm (fiction)',
    description: 'Check that dialogue sounds natural and narration flows smoothly'
  },

  // Tab 8: Gospel Resonance Pass
  {
    id: 'gospel-1',
    tab: 'Gospel Resonance Pass',
    label: 'Message aligns with Scripture',
    description: 'Verify that your content is theologically sound and biblically grounded'
  },
  {
    id: 'gospel-2',
    tab: 'Gospel Resonance Pass',
    label: 'Tone reflects humility and grace',
    description: 'Ensure your writing voice demonstrates Christ-like character'
  },
  {
    id: 'gospel-3',
    tab: 'Gospel Resonance Pass',
    label: 'Encouragement is clear',
    description: 'Confirm that readers will feel hope and encouragement from your message'
  },
  {
    id: 'gospel-4',
    tab: 'Gospel Resonance Pass',
    label: 'No confusion or unintended messages',
    description: 'Review for any content that could be misunderstood or misleading'
  },
  {
    id: 'gospel-5',
    tab: 'Gospel Resonance Pass',
    label: 'Spiritual impact intentional',
    description: 'Ensure every chapter serves your overall spiritual purpose'
  },

  // Tab 9: Final Publishing Review
  {
    id: 'final-1',
    tab: 'Final Publishing Review',
    label: 'Ebook file ready',
    description: 'Final ebook file is formatted, proofread, and ready for upload'
  },
  {
    id: 'final-2',
    tab: 'Final Publishing Review',
    label: 'Print file ready',
    description: 'Print-ready PDF is properly formatted with correct margins and spacing'
  },
  {
    id: 'final-3',
    tab: 'Final Publishing Review',
    label: 'All metadata complete',
    description: 'Title, subtitle, description, and author bio are finalized'
  },
  {
    id: 'final-4',
    tab: 'Final Publishing Review',
    label: 'Cover files final',
    description: 'Both ebook and print cover files are in final, approved versions'
  },
  {
    id: 'final-5',
    tab: 'Final Publishing Review',
    label: 'Keywords & categories tested',
    description: 'Research confirms your keyword and category strategy is optimized'
  },
  {
    id: 'final-6',
    tab: 'Final Publishing Review',
    label: 'Author bio & back matter complete',
    description: 'All back matter elements are written and properly formatted'
  },
  {
    id: 'final-7',
    tab: 'Final Publishing Review',
    label: 'Audio Pass complete',
    description: 'Text-to-speech review has been completed and issues resolved'
  },
  {
    id: 'final-8',
    tab: 'Final Publishing Review',
    label: 'Gospel Resonance Pass complete',
    description: 'Spiritual and theological review has been completed satisfactorily'
  }
];

export const tabOrder = [
  'Metadata Setup',
  'Interior File Prep',
  'Cover File Prep',
  'Keywords & Categories',
  'ISBN + Copyright',
  'Back Matter & Author Bio',
  'Audio Read Pass',
  'Gospel Resonance Pass',
  'Final Publishing Review'
];

export const tabDescriptions = {
  'Metadata Setup': 'Clarify your book\'s promise and presentation.',
  'Interior File Prep': 'Prepare your manuscript for upload.',
  'Cover File Prep': 'Your book\'s first impression.',
  'Keywords & Categories': 'Help readers find your book.',
  'ISBN + Copyright': 'Protect your work and assign identifiers.',
  'Back Matter & Author Bio': 'Turn readers into returning readers.',
  'Audio Read Pass': 'Hear your manuscript through fresh ears.',
  'Gospel Resonance Pass': 'Ensure spiritual clarity and faithfulness.',
  'Final Publishing Review': 'Your book is nearly ready!'
};

export const tabPrompts = {
  'Metadata Setup': [
    'Is your title clear rather than clever?',
    'Does your description emotionally or spiritually connect with your reader?',
    'Would a reader immediately understand who this book is for?'
  ],
  'Interior File Prep': [
    'Your interior file should disappear — the reader should feel the flow, not the formatting.'
  ],
  'Cover File Prep': [
    'Your cover is your book\'s first promise. Does it match what your reader expects and needs?'
  ],
  'Keywords & Categories': [
    'If someone needed your book, what would they type into Amazon?',
    'Borrow strength from comparable titles.'
  ],
  'ISBN + Copyright': [
    'Using your own ISBN provides more long-term flexibility, but KDP\'s free ISBN works fine too.'
  ],
  'Back Matter & Author Bio': [
    'Your back matter is where casual readers become committed readers.'
  ],
  'Audio Read Pass': [
    'Audio reveals what the eyes miss. Listen for where you stumble or disconnect.'
  ],
  'Gospel Resonance Pass': [
    'Does this reflect the heart of Christ in its message and tone?',
    'Where will your reader feel encouraged, challenged, or comforted?'
  ],
  'Final Publishing Review': [
    'Faithfulness is not perfection — it\'s intentional stewardship. You are ready.'
  ]
};